import * as recallApi from '@otter-ai/recall-client';
import { useMutation } from '@tanstack/react-query';

export const useAcceptInvitationMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (res: recallApi.AcceptInvitationResponse) => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  return useMutation({
    mutationFn: async ({
      userid,
      workspaceId,
    }: {
      userid?: string;
      workspaceId: string;
    }) => {
      const query = {
        userid,
      };

      const body = {
        workspace_id: workspaceId,
      };

      const response = await recallApi.acceptInvitation({
        query,
        body,
        throwOnError: true,
      });

      return response.data;
    },
    onSuccess,
    onError,
  });
};
